import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface CarryMemberAgreementButtonProps {
  agreementId: string | null;
  onOpen: (agreementId: string) => void;
  disabled?: boolean;
}

export function CarryMemberAgreementButton({
  agreementId,
  onOpen,
  disabled = false,
}: CarryMemberAgreementButtonProps) {
  return (
    <Button
      variant="outline"
      disabled={!agreementId || disabled}
      title={agreementId ? undefined : 'No member agreement yet'}
      onClick={() => agreementId && onOpen(agreementId)}
    >
      <FileText className="mr-2 h-4 w-4" />
      Member agreement
    </Button>
  );
}
